/* wellinda-reviews — native-scroll rail with arrows and a progress bar.
   Self-contained: only touches elements inside its own section. */
(function () {
  'use strict';

  function init(root) {
    var rail = root.querySelector('[data-wrev-rail]');
    var fill = root.querySelector('[data-wrev-fill]');
    var prev = root.querySelector('[data-wrev-prev]');
    var next = root.querySelector('[data-wrev-next]');
    if (!rail) return;

    function step() {
      var card = rail.querySelector('[data-wrev-card]');
      if (!card) return rail.clientWidth;
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth;
      // the bar shows how much of the rail is visible, moved along by the scroll
      var visible = rail.clientWidth / rail.scrollWidth;
      var progress = max > 0 ? rail.scrollLeft / max : 0;
      if (fill) {
        fill.style.width = Math.max(visible * 100, 8) + '%';
        fill.style.transform =
          'translateX(' + progress * ((1 / Math.max(visible, 0.0001)) - 1) * 100 + '%)';
      }
      if (prev) prev.disabled = rail.scrollLeft <= 1;
      if (next) next.disabled = rail.scrollLeft >= max - 1;
    }

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wrev]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wrev]');
    if (root) init(root);
  });
})();
